export type RunStatus = 'success' | 'warning' | 'failed';

/**
 * Full derivation used by the backend stream consumer, where run status AND
 * test results (blockers/warnings) are known.
 *  - failed  : run ERRORED/FAILURE, or any blocking test failed
 *  - warning : run succeeded but at least one non-blocking test produced a warning
 *  - success : run succeeded, no failing tests
 */
export function deriveRunStatus(p: {
  status: string;
  blockers: number;
  warnings: number;
}): RunStatus {
  if (p.status === 'ERRORED' || p.status === 'FAILURE' || p.blockers > 0) return 'failed';
  if (p.warnings > 0) return 'warning';
  return 'success';
}

/**
 * Fallback for the frontend when `lastRunStatus` has not been populated yet
 * (legacy datasets). Only the cached run status is available — no warning info —
 * so this resolves to success/failed only.
 */
export function deriveRunStatusFallback(status: string | undefined): RunStatus {
  if (status === 'FAILURE' || status === 'ERRORED') return 'failed';
  return 'success';
}
